import React from 'react'
// import Statuspick from '../statuspick'
import AddNewForm from './AddNewForm'
import Datepick from '../datepick'
import moment from 'moment'
// import DropdownMenu from './DropdownMenu'
import CodeEditorModal from './CodeEditorModal'


class MappingFieldRow extends React.PureComponent {
    constructor(props) {
        super(props)

        this.handleLocalChange = this.handleLocalChange.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.onExpandClick = this.onExpandClick.bind(this)
        this.handleAddChildRow = this.handleAddChildRow.bind(this)
        this.handleDatatypeClick = this.handleDatatypeClick.bind(this)
        this.handleDatatypeBlur = this.handleDatatypeBlur.bind(this)
        this.handleKeyPress = this.handleKeyPress.bind(this)

        this.fromInput = HTMLInputElement
        this.toInput = HTMLInputElement
        this.expandButton = React.createRef()
        this.dataTypeDropdown = HTMLSelectElement

        this.state = {
            mappingField: { ...this.props.mappingField },
            errors: { ...this.props.errors },
            expanded: false,
            editDataType: false,
        }

    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            mappingField: { ...nextProps.mappingField },
            errors: { ...nextProps.errors }
        })
    }

    componentDidMount() {
        this.props.setRef(this)
        if (this.state.field_from === "" || this.props.mappingField.newRow) {
            this.fromInput.scrollIntoView({ block: "center" })
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.isParent && !prevProps.isParent && this.expandButton) {
            this.expandButton.click()
        }
    }

    handleAddChildRow(e, datatype) {

        let result = { success: true }
        if (this.props.onAddChildRow && typeof this.props.onAddChildRow === "function") {
            result = this.props.onAddChildRow(e, datatype)
        }

        if (this.props.isParent && this.expandButton && this.expandButton.getAttribute("aria-expanded") === "false") {
            this.expandButton.click()
        }
        

        return result
    }

    componentWillUnmount() {
        this.props.setRef(undefined)
    }

    focusInput(inputName) {
        if (inputName === "field_from") {
            this.fromInput.focus()
        } else if (inputName === "field_to") {
            this.toInput.focus()
        }
    }

    handleLocalChange(e) {
        let fieldName = e.target.getAttribute("name").split(".")[1]
        let newValue = e.target.value
        // console.log("fieldName " + fieldName)
        // console.log("newValue " + newValue)

        this.setState({
            mappingField: {
                ...this.state.mappingField,
                [fieldName]: newValue
            }
        })
        // console.log('STATE ASDASDASD',this.state.mappingField)
    }

    handleChange(e) {

        let newDateValue = e
        let staticValue = "01-01-2019"
        // console.log("newDateValue" + newDateValue)
        // console.log("newDateValue" + typeof newDateValue)

        this.setState({
            mappingField: {
                ...this.state.mappingField,
                'defaultvalue': staticValue
            }
        })



    }

    onExpandClick(e) {
        let newVal = !this.state.expanded
        if (typeof this.props.onExpand === "function") {
            this.props.onExpand(newVal, this.props.mappingFieldIndex)
        }

        this.setState({ expanded: newVal })
    }

    handleDatatypeClick(e, allowChangeDataType) {
        if (allowChangeDataType) {
            this.setState({
                editDataType: !this.state.editDataType
            }, () => {
                this.dataTypeDropdown.focus()
            })
        }
    }

    handleDatatypeBlur(e) {
        this.props.onChange(e)
        this.setState({
            editDataType: false
        })
    }

    handleKeyPress(e) {
        if (e.target.type === "number" && (e.charCode === 69 || e.charCode === 101 || e.charCode === 46 || e.charCode === 45 || e.charCode === 43)) {
            e.preventDefault()
            e.stopPropagation()
        }
    }

    render() {
        let {
            mappingFieldIndex,
            onChange,
            allowAdd,
            allowDelete,
            allowedTypes,
            currentUser,
            createdBy
        } = this.props

        if(allowedTypes){
            allowedTypes.push('List')
        }
      
        //console.log('allowedTypes',allowedTypes)
        // Default allowDelete to true if prop was not specified
        let finalAllowDelete = allowDelete !== undefined ? allowDelete : true

        let allowEdit = createdBy === currentUser || finalAllowDelete || createdBy === undefined

        let {
            mappingField,
            errors
        } = this.state

        let isDataTypeId = mappingField.datatype === "e-id" || mappingField.datatype === "p-id"

        let isDateType = mappingField.datatype === "date" ? true : false
        let newDate

        if (isDateType == true) {
            newDate = moment().format('MM-DD-YYYY HH:mm:ss')
        }

        let allowChangeDataType = mappingField.datatype === "value" ||
            mappingField.datatype === "boolean" ||
            mappingField.datatype === "percent" ||
            mappingField.datatype === "text" ||
            mappingField.datatype === "time" ||
            mappingField.datatype === "date" ||
            mappingField.datatype === "datetime"||
            mappingField.datatype === "list"


        let dataTypeDropdown = (
            <select className="form-control input-sm fieldmapping-datatype"
                ref={el => this.dataTypeDropdown = el}
                disabled={!allowChangeDataType || !allowEdit}
                name={`mappingFields[${mappingFieldIndex}].datatype`}
                onChange={e => { onChange(e); this.setState({ editDataType: false }) }}
                onBlur={this.handleDatatypeBlur}
                onFocus={e => e.target.click()}
                value={mappingField.datatype}
            >

                {!allowChangeDataType && <option value="e-id" >E-ID</option>}
                {!allowChangeDataType && <option value="p-id" >P-ID</option>}
                {!allowChangeDataType && <option value="s-id" >S-ID</option>}
                {!allowChangeDataType && <option value="f-id" >F-ID</option>}
                <option value="value">value</option>
                <option value="boolean">boolean</option>
                <option value="percent">percent</option>
                <option value="text">text</option>
                <option value="time">time</option>
                <option value="date">date</option>
                <option value="datetime">datetime</option>
                <option value="list">list</option>
                {!allowChangeDataType && <option value="object" >Object</option>}
                {!allowChangeDataType && <option value="array" >Array</option>}
                {!allowChangeDataType && <option value="meta" >Meta</option>}
            </select>
        )

        let enableMaxLength = false

        if (mappingField.datatype === "value" || mappingField.datatype === "text") {
            enableMaxLength = true
        }

        let childSpacersFrom = []
        let childSpacersTo = []
        if (this.props.isChild && this.props.tierCount) {
            for (let i = 0; i < this.props.tierCount; i++) {
                childSpacersFrom.push(<span key={`child-spacer-${mappingFieldIndex}-${i}-from`} className="row-child-spacer"></span>)
                childSpacersTo.push(<span key={`child-spacer-${mappingFieldIndex}-${i}-to`} className="row-child-spacer"></span>)
            }
        }

        // console.log("mappinField", mappingField)


        return (
            <div className="fieldmapping-row row pt-1">
                <div className="col-3 px-1">
                    <div className="row align-items-start h-100">
                        {this.props.isChild ?
                            childSpacersFrom : null
                        }

                        {this.props.isParent ?
                            <button type="button" ref={node => this.expandButton = node} className="row-expand-btn" data-toggle="collapse" data-bs-toggle="collapse" aria-expanded={this.state.expanded} aria-controls={`child-section-${mappingFieldIndex}`} data-target={`#child-section-${mappingFieldIndex}`} data-bs-target={`#child-section-${mappingFieldIndex}`}>
                                <i className="fa fa-caret-right fa-fw"></i>
                            </button> :
                            <span className="row-expand-spacer">
                                <i className="fa fa-fw"></i>
                            </span>
                        }
                        <div className="col no-gutters">
                            <input className={"form-control" + (errors && errors.field_from ? " is-invalid" : "")}
                                name={`mappingFields[${mappingFieldIndex}].field_from`}
                                onChange={this.handleLocalChange}
                                onBlur={onChange}
                                ref={node => this.fromInput = node}
                                value={mappingField.field_from || ""}
                                required
                                // readOnly={!allowEdit}
                            />
                            <div className="invalid-feedback">
                                {errors && errors.field_from ? errors.field_from : ""}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-3 px-1">
                    <div className="row align-items-start h-100">
                        {this.props.isChild ?
                            childSpacersTo : null
                        }
                        <div className="col no-gutters">
                            <input className={"form-control" + (errors && errors.field_to ? " is-invalid" : "")}
                                name={`mappingFields[${mappingFieldIndex}].field_to`}
                                onChange={this.handleLocalChange}
                                onBlur={onChange}
                                ref={node => this.toInput = node}
                                value={mappingField.field_to || ""}
                                // readOnly={!allowEdit}
                            />
                            <div className="invalid-feedback">
                                {errors && errors.field_to ? errors.field_to : ""}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-1-2 px-1 no-gutters ">
                    <div className="input-group align-items-start h-100">
                        <input className={"form-control" + (errors && errors.defaultvalue ? " is-invalid" : "")}
                            name={`mappingFields[${mappingFieldIndex}].defaultvalue`}
                            onChange={this.handleLocalChange}
                            onBlur={onChange}
                            alt={mappingField.defaultvalue || ""}
                            title={mappingField.defaultvalue || ""}
                            value={mappingField.defaultvalue || ""}
                            // readOnly={!allowEdit}
                        />
                        <div className="invalid-feedback">
                            {errors && errors.defaultvalue ? errors.defaultvalue : ""}
                        </div>
                    </div>
                </div>
                <div className="col-1-2 px-1 btn-group align-items-start justify-content-center">
                    {this.state.editDataType ?
                        dataTypeDropdown
                        : <div className={"badge badge-light w-100 align-items-center d-flex" + (!allowChangeDataType ? " no-edit" : "")}
                            onClick={e => { this.handleDatatypeClick(e, allowChangeDataType) }}>
                            {mappingField.datatype}
                        </div>
                    }
                </div>
                <div className="col-1-2 px-1 no-gutters">
                    <div className="input-group align-items-start h-100">
                        <input className={"form-control" + (errors && errors.max_length ? " is-invalid" : "")}
                            name={`mappingFields[${mappingFieldIndex}].max_length`}
                            onChange={this.handleLocalChange}
                            onBlur={onChange}
                            alt={mappingField.max_length || ""}
                            title={mappingField.max_length || ""}
                            value={mappingField.max_length || ""}
                            type="number"
                            onKeyPress={this.handleKeyPress}
                            disabled={!enableMaxLength}
                            // readOnly={!allowEdit}
                        />
                        <div className="invalid-feedback">
                            {errors && errors.max_length ? errors.max_length : ""}
                        </div>
                    </div>
                </div>
                <div className="col-1-2 pl-4 no-gutters text-md-center">

                    <input type="checkbox"
                        className="form-check-input"
                        name={`mappingFields[${mappingFieldIndex}].is_truncated`}
                        id={`mappingFields[${mappingFieldIndex}].is_truncated`}
                        value={mappingField.is_truncated}
                        onChange={e => {
                            e.target.value = e.target.checked ? 1 : 0
                            this.handleLocalChange(e)
                            onChange(e)
                        }}
                        checked={mappingField.is_truncated ? true : false}
                        disabled={!enableMaxLength}
                        // readOnly={!allowEdit}
                    />
                    <label className="form-check-label" htmlFor={`mappingFields[${mappingFieldIndex}].is_truncated`}></label>

                </div>
                <div className="col-1-2 no-gutters text-md-center">
                    <input type="checkbox"
                        className="form-check-input"
                        name={`mappingFields[${mappingFieldIndex}].update_flag`}
                        id={`mappingFields[${mappingFieldIndex}].update_flag`}
                        value={mappingField.update_flag}
                        onChange={e => {
                            e.target.value = e.target.checked ? 1 : 0
                            this.handleLocalChange(e)
                            onChange(e)
                        }}
                        checked={mappingField.update_flag ? true : false}
                        disabled={(isDataTypeId && mappingField.update_flag === 1)}
                        // readOnly={!allowEdit}
                    />
                    <label className="form-check-label" htmlFor={`mappingFields[${mappingFieldIndex}].update_flag`}></label>

                </div>
                <div className="col-1-2 no-gutters text-md-center">

                    {/* <Statuspick
                        name={`mappingFields[${mappingFieldIndex}].mandatory`}
                        className="form-control"
                        onChange={onChange}
                        showText={false}
                        defaultChecked={mappingField.mandatory ? true: false}
                        status={mappingField.mandatory ? 1 : 0} /> */}

                    <input type="checkbox"
                        className="form-check-input"
                        name={`mappingFields[${mappingFieldIndex}].mandatory`}
                        id={`mappingFields[${mappingFieldIndex}].mandatory`}
                        value={mappingField.mandatory}
                        onChange={e => {
                            e.target.value = e.target.checked ? 1 : 0
                            this.handleLocalChange(e)
                            onChange(e)
                        }}
                        checked={mappingField.mandatory ? true : false}
                        disabled={(isDataTypeId && mappingField.update_flag === 1) }
                        // readOnly={!allowEdit}
                    />
                    <label className="form-check-label" htmlFor={`mappingFields[${mappingFieldIndex}].mandatory`}></label>

                </div>
                <div className="col-1-2 no-gutters text-md-center" id="allow-null">
                    <div className="test">
                        <input type="checkbox"
                            className="form-check-input"
                            name={`mappingFields[${mappingFieldIndex}].allow_null`}
                            id={`mappingFields[${mappingFieldIndex}].allow_null`}
                            value={ mappingField.mandatory == 1 ? 0 : mappingField.allow_null }
                            onChange={e => {
                                e.target.value = e.target.checked ? 1 : 0
                                this.handleLocalChange(e)
                                onChange(e);
                            }}
                            checked={mappingField.allow_null ? this.state.mappingField.mandatory == 1 ? false : true : false}
                            disabled={(isDataTypeId && mappingField.update_flag === 1)  || (this.state.mappingField.mandatory == 1) }
                            // readOnly={!allowEdit}
                        />
                        <label className="form-check-label" htmlFor={`mappingFields[${mappingFieldIndex}].allow_null`}></label>
                    </div>
                </div>
               
                <div className="col-1-2 text-right align-items-end">
                    <div className="btn-group btn-group-xs" role="group">
                        {/* Hide  transformation and validation for now */}
                        <CodeEditorModal
                            id={`mappingFields[${mappingFieldIndex}].transformation`}
                            name={`mappingFields[${mappingFieldIndex}].transformation`}
                            modalTitle="Transformation"
                            onChange={onChange}
                            value={mappingField.transformation || ""}
                            enforceArgs={["val"]}
                            buttonText={(<i className="fas fa-retweet"></i>)}
                            buttonTitle="transformation"
                        />
                        {/*<CodeEditorModal
                        id={`mappingFields[${mappingFieldIndex}].validation`}
                        name={`mappingFields[${mappingFieldIndex}].validation`}
                        modalTitle="Validation"
                        onChange={onChange}
                        value={mappingField.validation || ""}
                        enforceArgs={["val", "context"]}
                        buttonText={(<i className="fas fa-not-equal"></i>)}
                        buttonTitle="validation"
                    /> */}

                        {allowAdd /*(this.props.isParent || mappingField.datatype === "object" || mappingField.datatype === "meta" || mappingField.datatype === "array")*/ ?
                            <AddNewForm id={`add-new-mappingfieldrow-${mappingFieldIndex}`}
                                type="object"
                                parentType="object"
                                parentKey=""
                                onAdd={this.handleAddChildRow}
                                allowedTypes={allowedTypes}
                                // allowedTypes={[["F-Id", "Value", "Boolean", "Percent", "Text", "List"]]}
                                placeholder="Source Field" />
                            : null
                        }
                        {finalAllowDelete || this.props.currentUser === this.props.createdBy || createdBy === undefined ?
                            <button type="button" className="btn btn-danger ml-1" data-toggle="tooltip" data-placement="top" title="delete" onClick={this.props.onDelete}>
                                <i className="fa fa-trash"></i>
                            </button> : null
                        }
                    </div>


                </div>

            </div>

        )

    }
}

/*<button type="button" className="btn btn-danger ml-1" data-toggle="tooltip" data-placement="top" title="delete" onClick={this.props.onDelete}></button>*/


export default MappingFieldRow


// WEBPACK FOOTER //
// ./src/components/utilities/MappingFieldRow.js